import * as React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useResponsive } from "../../hooks/useResponsive";

import DocumentIcon from "../../assets/Icon/NavIcons/DocumentsIcon";

import DriverIcon from "../../assets/Icon/NavIcons/MyDriversIcon";
import { ReactComponent as Language } from "../../assets/svg/language.svg";

import HouseIcon from "../../assets/Icon/NavIcons/HomeIcon";

import ReservationIcon from "../../assets/Icon/NavIcons/ReservationIcon";

import { ReactComponent as BillingIcon } from "../../assets/svg/billingIconSvg.svg";
import { ReactComponent as SignOutIcon } from "../../assets/svg/SignOutIcon.svg";

import VehicleIcon from "../../assets/Icon/NavIcons/MyVehiclesIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleIsClosingVariable,
  toggleMobileOpenVariable,
} from "../../redux/menuBar/action";
import storePersist, { localConstant } from "../../services/localStorage";
import logo from "../../assets/safe_truck_drawer_logo.png";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BillingPaymentIcon from "../../assets/Icon/NavIcons/billingPayment";
import { isMobileDeviceCheck, sendMessageToReactNative } from "../../utils";
import EnterIcon from "../../assets/Icon/EnterIcon";

const drawerWidth = 240;

const MenuBar = ({ myRef, activeTab }) => {
  const { mobileOpen, isClosing } = useSelector(
    (state) => state.menuBarReducer,
  );

  const lgUp = useResponsive("up", "lg");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const nativePlatform = storePersist.get(localConstant.NATIVE_PLATFORM);

  const handleDrawerClose = () => {
    dispatch(toggleIsClosingVariable(true));
    dispatch(toggleMobileOpenVariable(false));
  };

  const handleDrawerTransitionEnd = () => {
    dispatch(toggleIsClosingVariable(false));
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      dispatch(toggleMobileOpenVariable(!mobileOpen));
    }
  };

  const { i18n, t } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const [language, setLanguage] = useState(
    storePersist.get(localConstant.LANGUAGE)
      ? storePersist.get(localConstant.LANGUAGE)
      : i18n?.language?.split("-")?.[0],
  );

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
    changeLanguage(e.target.value);
    storePersist.set(localConstant.LANGUAGE, e.target.value);
  };

  const mainMenu = () => {
    return storePersist.get(localConstant.SUPER_ADMIN) && isMobileDeviceCheck()
      ? [
          {
            label: t("components.menuDrawer.mainMenu.item01"),
            link: "/ownerDashboard",
            icon: (
              <HouseIcon
                width="24"
                height="24"
                active={activeTab === 0}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 0,
          },
          {
            label: t("components.menuDrawer.mainMenu.item02"),
            link: "/reservation",
            icon: (
              <ReservationIcon
                width="24"
                height="24"
                active={activeTab === 1}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 1,
          },

          {
            label: t("components.menuDrawer.mainMenu.item03"),
            link: "/vehiclesList",
            icon: (
              <VehicleIcon
                width="24"
                height="24"
                active={activeTab === 2}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 2,
          },
          {
            label: t("components.menuDrawer.mainMenu.item04"),
            link: "/driversList",
            icon: (
              <DriverIcon
                width="24"
                height="24"
                active={activeTab === 3}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 3,
          },
          {
            label: t("components.menuDrawer.mainMenu.item06"),
            link: "/documents",
            icon: (
              <DocumentIcon
                width="28"
                height="29"
                active={activeTab === 5}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 5,
          },
          {
            label: t("components.menuDrawer.mainMenu.item07"),
            link: "/billing_payments",
            icon: (
              <BillingPaymentIcon
                width="28"
                height="29"
                active={activeTab === 6}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 6,
          },
          {
            label: t("components.menuDrawer.mainMenu.item08"),
            link: "/gates_list",
            icon: (
              <EnterIcon
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
                width="28px"
                height="28px"
                active={activeTab === 7}
              />
            ),
            active: activeTab === 7,
          },
        ]
      : [
          {
            label: t("components.menuDrawer.mainMenu.item01"),
            link: "/ownerDashboard",
            icon: (
              <HouseIcon
                width="24"
                height="24"
                active={activeTab === 0}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 0,
          },
          {
            label: t("components.menuDrawer.mainMenu.item02"),
            link: "/reservation",
            icon: (
              <ReservationIcon
                width="24"
                height="24"
                active={activeTab === 1}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 1,
          },

          {
            label: t("components.menuDrawer.mainMenu.item03"),
            link: "/vehiclesList",
            icon: (
              <VehicleIcon
                width="24"
                height="24"
                active={activeTab === 2}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 2,
          },
          {
            label: t("components.menuDrawer.mainMenu.item04"),
            link: "/driversList",
            icon: (
              <DriverIcon
                width="24"
                height="24"
                active={activeTab === 3}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 3,
          },
          {
            label: t("components.menuDrawer.mainMenu.item06"),
            link: "/documents",
            icon: (
              <DocumentIcon
                width="28"
                height="29"
                active={activeTab === 5}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 5,
          },
          {
            label: t("components.menuDrawer.mainMenu.item07"),
            link: "/billing_payments",
            icon: (
              <BillingPaymentIcon
                width="28"
                height="29"
                active={activeTab === 6}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 6,
          },
        ];
  };

  const subMenu = [
    {
      label: "Change Language",
      link: null, // Language change shouldnt call navigate
      icon: <Language />,
      element: (
        <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
          <Select
            labelId="language_dropdown_label"
            id="language_dropdown"
            value={language}
            label=""
            onChange={handleLanguageChange}
            sx={{
              color: "white", // Text color
              "& .MuiSvgIcon-root": { color: "white" }, // Dropdown icon color
              "&:before": { border: "none" }, // Remove underline color before click
              "&:after": { border: "none" }, // Remove underline color after click
              "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Remove border for Outlined variant
              "& .MuiSelect-select": {
                p: 0, // Remove padding inside the select
                // Additional customization for focus background color
                "&:focus": { backgroundColor: "transparent" },
              },
              // This targets the dropdown icon specifically, adjusting if necessary
              "& .MuiSelect-icon": {
                color: "white",
              },
            }}
          >
            <MenuItem value={"en"}>English</MenuItem>
            <MenuItem value={"es"}>Español</MenuItem>
            <MenuItem value={"ru"}>Русский</MenuItem>
          </Select>
        </FormControl>
      ),
    },
    {
      label: t("components.menuDrawer.subMenu.item03"),
      link: "/login",
      icon: <SignOutIcon />,
    },
  ];

  const mainMenuOperator = () => {
    return storePersist.get(localConstant.SUPER_ADMIN) && isMobileDeviceCheck()
      ? [
          {
            label: t("components.menuDrawer.mainMenu.item01"),
            link: "/operatorDashboard",
            icon: (
              <HouseIcon
                width="24"
                height="24"
                active={activeTab === 0}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 0,
          },
          {
            label: t("components.menuDrawer.mainMenu.item02"),
            link: "/reservation",
            icon: (
              <ReservationIcon
                width="24"
                height="24"
                active={activeTab === 1}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 1,
          },
          {
            label: t("components.menuDrawer.mainMenu.item06"),
            link: "/documents",
            icon: (
              <DocumentIcon
                width="28"
                height="29"
                active={activeTab === 5}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 5,
          },
          {
            label: t("components.menuDrawer.mainMenu.item08"),
            link: "/gates_list",
            icon: (
              <EnterIcon
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
                width="28px"
                height="28px"
                active={activeTab === 6}
              />
            ),
            active: activeTab === 6,
          },
        ]
      : [
          {
            label: t("components.menuDrawer.mainMenu.item01"),
            link: "/operatorDashboard",
            icon: (
              <HouseIcon
                width="24"
                height="24"
                active={activeTab === 0}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 0,
          },
          {
            label: t("components.menuDrawer.mainMenu.item02"),
            link: "/reservation",
            icon: (
              <ReservationIcon
                width="24"
                height="24"
                active={activeTab === 1}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 1,
          },
          {
            label: t("components.menuDrawer.mainMenu.item06"),
            link: "/documents",
            icon: (
              <DocumentIcon
                width="28"
                height="29"
                active={activeTab === 5}
                activeColor="white"
                inActiveColor="rgba(255,255,255, 0.5)"
              />
            ),
            active: activeTab === 5,
          },
        ];
  };

  const subMenuOperator = [
    {
      label: "Change Language",
      link: null, // Language change shouldnt call navigate
      icon: <Language />,
      element: (
        <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
          <Select
            labelId="language_dropdown_label"
            id="language_dropdown"
            value={language}
            label=""
            onChange={handleLanguageChange}
            sx={{
              color: "white", // Text color
              "& .MuiSvgIcon-root": { color: "white" }, // Dropdown icon color
              "&:before": { border: "none" }, // Remove underline color before click
              "&:after": { border: "none" }, // Remove underline color after click
              "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Remove border for Outlined variant
              "& .MuiSelect-select": {
                p: 0, // Remove padding inside the select
                // Additional customization for focus background color
                "&:focus": { backgroundColor: "transparent" },
              },
              // This targets the dropdown icon specifically, adjusting if necessary
              "& .MuiSelect-icon": {
                color: "white",
              },
            }}
          >
            <MenuItem value={"en"}>
              {t("components.menuDrawer.subMenu.item01.option01")}
            </MenuItem>
            <MenuItem value={"es"}>
              {t("components.menuDrawer.subMenu.item01.option02")}
            </MenuItem>
            <MenuItem value={"ru"}>
              {t("components.menuDrawer.subMenu.item01.option03")}
            </MenuItem>
          </Select>
        </FormControl>
      ),
    },
    {
      label: t("components.menuDrawer.subMenu.item03"),
      link: "/login",
      icon: <SignOutIcon />,
    },
  ];

  myRef.current.handleDrawerToggle = handleDrawerToggle;

  const handleNavigate = (link, route) => {
    if (
      route === "Sign Out" ||
      route === "Выход" ||
      route === "Cerrar sesión"
    ) {
      storePersist.clear();
    }
    if (!isClosing) {
      if (!!link) navigate(link);
      dispatch(toggleMobileOpenVariable(!mobileOpen));
    }
  };

  const userType = storePersist.get(localConstant.USER_PROFILE);

  const mainMenuConfig =
    userType === "DRIVER" ? mainMenuOperator() : mainMenu();
  const subMenuConfig = userType === "DRIVER" ? subMenuOperator : subMenu;

  const drawer = (
    <div>
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          marginTop: "1rem",
        }}
      >
        <img src={logo} alt="logo" />
      </div>
      <List>
        <Divider
          style={{
            borderColor: "white",
            margin: "5% 5%",
          }}
        />
        {mainMenuConfig.map((item, index) => {
          return (
            <ListItem
              key={item.label}
              disablePadding
              onClick={() => {
                handleNavigate(item.link, item.label);
              }}
            >
              <ListItemButton
                style={
                  item.active
                    ? {
                        boxShadow:
                          "rgba(50, 50, 93, 0.25) 20px 0px 60px 10px inset, rgba(0, 0, 0, 0.3) 0px 0px 36px -16px inset",
                      }
                    : {}
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>

                <ListItemText
                  primary={item.label}
                  style={{
                    color: "white",
                  }}
                  primaryTypographyProps={{
                    fontWeight: item.active ? "bold" : "400",
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Divider
        style={{
          borderColor: "white",
          margin: "0 5%",
        }}
      />
      <List style={{ position: "absolute", bottom: 0, width: "100%" }}>
        {subMenuConfig.map((item, index) => (
          <ListItem
            key={item.label}
            disablePadding
            onClick={() => handleNavigate(item.link, item.label)}
          >
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              {item.element ? (
                item.element
              ) : (
                <ListItemText
                  primary={item.label}
                  style={{
                    color: "white",
                  }}
                />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: !lgUp ? "block" : "none",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "#1D5AB9",
              borderColor: "#1D5AB9",
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: !lgUp ? "none" : "block",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "#1D5AB9",
              borderColor: "#1D5AB9",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

MenuBar.defaultProps = {
  myRef: { current: {} },
};

export default MenuBar;
